<div class="home" data-testid="rrea-home-container">
  <div class="body">
    <div class="header">
      <img src="/assets/images/rrea/rrea-logo.png" width="137px">
      <div class="lessap-bg"></div>
    </div>
    <div class="main-content">
      <h1>Liberia Electricity Sector<br>Strengthening and Access Project</h1>
      <p> LESSAP is implemented by the Rural and Renewable Energy Agency (RREA) and the Liberia Electricity Corporation (LEC), with funding from the World Bank.</p>
    </div>
    <div class="main-image"></div>
    <div class="footer">
      <h3>Supported by</h3>
      <div class="footer-images">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/rrea/liberia-logo.png" width="118px">
        <img src="https://oes-hosted-images-public.s3.amazonaws.com/rrea/world-bank-logo.png" width="248px">
      </div>
    </div>
  </div>
</div>